import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const deleteUser = async (id) => {
  await axiosInstance.delete(`/promethee_admin/users/${id}/`);
};

export const useDeleteUser = (options = {}) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: deleteUser,
    onSuccess: (data, vars) => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'users'] });
      options.onSuccess?.(data, vars);
    },
    onError: options.onError,
  });
  return { deleteUser: mutation.mutateAsync, ...mutation };
};
